export default {
  en: {
    loading: 'Loading…',
    connecting: '{{name}} is connecting…',
    connectionFailed: 'Couldn’t connect to {{name}}',
    retry: 'Retry connection',
    close: 'Close conversation',
    settings: 'Conversation settings',
    sessionTime: 'Session time: {{time}}',
    vocabularyProgress: '{{used}}/{{total}} words',
  },
  ru: {
    loading: 'Загрузка…',
    connecting: '{{name}} подключается…',
    connectionFailed: 'Не удалось подключиться к {{name}}',
    retry: 'Повторить',
    close: 'Закрыть разговор',
    settings: 'Настройки разговора',
    sessionTime: 'Время сессии: {{time}}',
    vocabularyProgress: '{{used}}/{{total}} слов',
  },
  de: {
    loading: 'Wird geladen…',
    connecting: '{{name}} verbindet sich…',
    connectionFailed: 'Verbindung zu {{name}} fehlgeschlagen',
    retry: 'Erneut versuchen',
    close: 'Gespräch schließen',
    settings: 'Gesprächseinstellungen',
    sessionTime: 'Sitzungszeit: {{time}}',
    vocabularyProgress: '{{used}}/{{total}} Wörter',
  },
  pt: {
    loading: 'Carregando…',
    connecting: '{{name}} está conectando…',
    connectionFailed: 'Não foi possível conectar a {{name}}',
    retry: 'Tentar de novo',
    close: 'Fechar conversa',
    settings: 'Configurações da conversa',
    sessionTime: 'Tempo de sessão: {{time}}',
    vocabularyProgress: '{{used}}/{{total}} palavras',
  },
  fr: {
    loading: 'Chargement…',
    connecting: '{{name}} se connecte…',
    connectionFailed: 'Impossible de se connecter à {{name}}',
    retry: 'Réessayer',
    close: 'Fermer la conversation',
    settings: 'Paramètres de la conversation',
    sessionTime: 'Durée de la session : {{time}}',
    vocabularyProgress: '{{used}}/{{total}} mots',
  },
  es: {
    loading: 'Cargando…',
    connecting: '{{name}} se está conectando…',
    connectionFailed: 'No se pudo conectar con {{name}}',
    retry: 'Intentar de nuevo',
    close: 'Cerrar conversación',
    settings: 'Configuración de la conversación',
    sessionTime: 'Tiempo de sesión: {{time}}',
    vocabularyProgress: '{{used}}/{{total}} palabras',
  },
};
